import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MedicoPendenciaResponse } from '@/core/api/sicom-api/registro/medico/pendencia/medico-pendencia.model';
import { MedicoRneVencendoResponse } from '@/core/api/sicom-api/registro/medico/pendencia/medico-rne-vencendo.model';
import { MedicoPendenciaService } from '@/core/api/sicom-api/registro/medico/pendencia/medico-pendencia.service';
import { Page } from '@/shared/models/page.model';
import { CustomService } from '@/shared/services/custom.service';

@Injectable({ providedIn: 'root' })
export class MedicoPendenciaFeatureService extends CustomService {
    constructor(private core: MedicoPendenciaService) {
        super();
    }

    listarPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalPorUf(uf?: string | null): Observable<number> {
        return this.core.totalPorUf(uf).pipe(catchError(this.handleError));
    }

    listarCpfInvalidosOuNulosPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarCpfInvalidosOuNulosPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalCpfInvalidosOuNulosPorUf(uf?: string | null): Observable<number> {
        return this.core.totalCpfInvalidosOuNulosPorUf(uf).pipe(catchError(this.handleError));
    }

    listarGeneroNaoInformadoPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarGeneroNaoInformadoPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalGeneroNaoInformadoPorUf(uf?: string | null): Observable<number> {
        return this.core.totalGeneroNaoInformadoPorUf(uf).pipe(catchError(this.handleError));
    }

    listarDivergenciaDataNascimentoPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarDivergenciaDataNascimentoPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalDivergenciaDataNascimentoPorUf(uf?: string | null): Observable<number> {
        return this.core.totalDivergenciaDataNascimentoPorUf(uf).pipe(catchError(this.handleError));
    }

    listarEspecialidadePorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarEspecialidadePorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalEspecialidadePorUf(uf?: string | null): Observable<number> {
        return this.core.totalEspecialidadePorUf(uf).pipe(catchError(this.handleError));
    }

    listarFormaturaAntesCriacaoFaculdadePorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarFormaturaAntesCriacaoFaculdadePorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalFormaturaAntesCriacaoFaculdadePorUf(uf?: string | null): Observable<number> {
        return this.core.totalFormaturaAntesCriacaoFaculdadePorUf(uf).pipe(catchError(this.handleError));
    }

    listarFormaturaMaiorQueInscricaoPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarFormaturaMaiorQueInscricaoPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalFormaturaMaiorQueInscricaoPorUf(uf?: string | null): Observable<number> {
        return this.core.totalFormaturaMaiorQueInscricaoPorUf(uf).pipe(catchError(this.handleError));
    }

    listarEnderecoCorrespondenciaPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarEnderecoCorrespondenciaPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalEnderecoCorrespondenciaPorUf(uf?: string | null): Observable<number> {
        return this.core.totalEnderecoCorrespondenciaPorUf(uf).pipe(catchError(this.handleError));
    }

    listarPrazoDiplomaVencidoPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarPrazoDiplomaVencidoPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalPrazoDiplomaVencidoPorUf(uf?: string | null): Observable<number> {
        return this.core.totalPrazoDiplomaVencidoPorUf(uf).pipe(catchError(this.handleError));
    }

    listarCancelamentoComDebitoPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarCancelamentoComDebitoPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalCancelamentoComDebitoPorUf(uf?: string | null): Observable<number> {
        return this.core.totalCancelamentoComDebitoPorUf(uf).pipe(catchError(this.handleError));
    }

    listarInscritosAcima80AnosPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarInscritosAcima80AnosPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalInscritosAcima80AnosPorUf(uf?: string | null): Observable<number> {
        return this.core.totalInscritosAcima80AnosPorUf(uf).pipe(catchError(this.handleError));
    }

    listarRneVencendoEm30DiasPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoRneVencendoResponse>> {
        return this.core.listarRneVencendoEm30DiasPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalRneVencendoEm30DiasPorUf(uf?: string | null): Observable<number> {
        return this.core.totalRneVencendoEm30DiasPorUf(uf).pipe(catchError(this.handleError));
    }

    listarRneVencidoPorUf(uf?: string | null, page?: number, size?: number): Observable<Page<MedicoRneVencendoResponse>> {
        return this.core.listarRneVencidoPorUf(uf, page, size).pipe(catchError(this.handleError));
    }

    totalRneVencidoPorUf(uf?: string | null): Observable<number> {
        return this.core.totalRneVencidoPorUf(uf).pipe(catchError(this.handleError));
    }
}
